import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
  NgControl,
} from '@angular/forms';
// Animations
// Common
import {
  ErrorParseService,
  ICharitableContribution,
  IUser,
  LGEDataService,
  PermissionsService,
} from '../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromCharitableContribution from './state/charitable-contribution.selectors';
import * as fromRoot from '../../app/state/app.selectors';
import * as CharitableContributionAction from './state/charitable-contribution.actions';
import * as lgeApp from '../../app/state/app.actions';
import * as appConfig from '../../app/app.constant';
import {
  Router,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
import { DecimalPipe } from '@angular/common';
import {
  Observable,
  of,
  Subscription,
  catchError,
  first,
  map,
  skipWhile,
  exhaustMap,
} from 'rxjs';
import { createNumberMask } from 'text-mask-addons';
import { slideInDownAnimation } from 'src/app/app.animation';
import { DeactivationGuard } from 'src/commons/guards/route-change.guard';
import { FormCCService } from 'src/commons/services/formCC.service';
import { PreviousRouteService } from 'src/commons/services/previousRoute.service';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'charitable-contribution-screen',
  templateUrl: './charitable-contribution.component.html',
  styleUrls: ['./charitable-contribution.component.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharitableContributionScreenComponent
  implements OnInit, OnDestroy, DeactivationGuard
{
  @Input() pending$: Observable<boolean>;
  pendingSubscription: Subscription;
  pending: boolean;
  @Input() error$: Observable<string | null>;
  errorSubscription: Subscription;
  error: string | null;
  @Input() stateData$: Observable<ICharitableContribution | null>;
  stateDataSubscription: Subscription;
  // stateData: ICharitableContribution | null;

  @Input() userDetails$: Observable<IUser>;
  userDetailsSubscription: Subscription;
  userDetails: IUser | null;
  isAdmin = 'ADMIN';
  isApprover = 'APPROVER';
  isReviewer = 'REVIEWER';

  ccForm: FormGroup;
  charitableContribution: ICharitableContribution;
  formCCName = '';
  totalAmount = '0';
  hasNewAttach = false;

  isLoadingFormCC: boolean = false;
  isMaxLength = false;

  serviceAreas = appConfig.SHARE_ARRAYS.serviceAreas;
  states = appConfig.SHARE_ARRAYS.states;

  minEffdt = new Date('');
  minDuedt = new Date('');
  payToOption = false;
  contribTable = false;
  eventOrProgram = false;
  formId;
  formData;
  editMOde = false;
  isReadOnly = true;
  isAdminReadOnly = false;
  isShowLeaveDialog = false;
  pendingApprovalFormCCData;
  asAnApprovar: boolean = false;
  isApproved: boolean = false;
  isShowSaveAsDraft: boolean = true;
  asAnAdmin: boolean = true;
  atOeBs: boolean = true;
  // isRejected: boolean = false;
  isWithdrawn: boolean = false;
  orgInfoData = null;
  isFilled: boolean = true;
  isValid: boolean = true;
  validateResult;
  ValidatingRow: number;
  isValidatingRow: boolean = false;
  taxExemptList = [];

  base64String: string = '';

  w9FormName = [];
  w9Form: string = '';
  w9FileName: string = '';
  w9FileSize: string = '';

  totalFileCount: number = 0;
  totalFileSize: number = 0;
  addAttachData: any = [];
  fileNames = [];
  // fileArray: any = [];
  fileList: any = [];

  base64;
  isShowEmpID = false;

  @ViewChild('fileInput1') fileInput1: ElementRef;
  @ViewChild('fileInput2') fileInput2: ElementRef;

  companyData: any = [];
  expTypeData: any = [];
  expTypeData501c3: any = [];
  expTypeDataNon501c3: any = [];
  expOrgData: any = [];
  projTaskData: any = [];
  projTaskData501c3: any = [];
  projTaskDataNon501c3: any = [];

  // projTask: any = [[], [], [], []];

  accDistData: any = [
    { company: [], project: [], task: [], expOrg: [], expType: [] },
    { company: [], project: [], task: [], expOrg: [], expType: [] },
    { company: [], project: [], task: [], expOrg: [], expType: [] },
    { company: [], project: [], task: [], expOrg: [], expType: [] },
  ];

  currencyMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 12,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: false,
  });

  numPipe = new DecimalPipe('en-Us');

  @HostListener('window:beforeunload', ['$event'])
  handleClose($event) {
    if (!this.isShowLeaveDialog && this.ccForm.dirty) {
      $event.returnValue = 'Message here';
      return false;
    }
    return true;
  }

  constructor(
    private store: Store<fromCharitableContribution.State>,
    private storeRoot: Store<fromRoot.AppState>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private errorParse: ErrorParseService,
    private _dataService: LGEDataService,
    private permissionsService: PermissionsService,
    private previousRouteService: PreviousRouteService,
    private router: Router,
    private route: ActivatedRoute,
    private formCCService: FormCCService,
    private toastrService: ToastrService // private appComponent: AppComponent
  ) {
    this.selectState();
    this._dataService.GetTaxExemptSubsections().subscribe({
      next: () => (this.taxExemptList = appConfig.SHARE_ARRAYS.taxExemptList),
    });
  }

  ngOnInit() {
    this.userDetails = this._dataService.getEmployeeDetails();
    this.isShowEmpID =
      environment.MVC_URL.includes('testui') ||
      environment.MVC_URL.includes('devui') ||
      environment.MVC_URL.includes('localhost');
    this.createForms();

    this.route.params.subscribe((response) => {
      this.formId = parseInt(response['id']);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.startSubscriptions();
      if (this.formId) {
        this.store.dispatch(
          new CharitableContributionAction.LoadCharitableContributionState(
            this.formId
          )
        );
      } else {
        setTimeout(() => {
          this.checkOrgName();
          this.ams.closeDialog();
          this.ref.markForCheck();
        });
      }
      this.ref.markForCheck();
    });
  }

  getAccountingDistributionData(accDistPara) {
    this._dataService
      .AccDistInfo_GetActiveByName([accDistPara, 'CC'])
      .subscribe({
        next: (data) => {
          if (data) {
            switch (accDistPara) {
              case 'COMPANY':
                this.companyData = data;
                for (let i = 0; i < this.accDistData.length; i++) {
                  // 4 to this.accDistData.length
                  this.accDistData[i].company = data;
                }
                // console.log('this.companyData')
                // console.log(this.companyData)
                break;
              case 'EXP_TYPE':
                this.expTypeData = data;
                this.expTypeData501c3 = this.expTypeData.filter(
                  (type) => type.code !== '0647'
                );
                this.expTypeDataNon501c3 = this.expTypeData.filter(
                  (type) => type.code !== '0646'
                );
                for (let i = 0; i < this.accDistData.length; i++) {
                  // 4 to this.accDistData.length
                  this.accDistData[i].expType = this.expTypeData;
                }
                this.filterExpTypeTask();
                break;
              case 'EXP_ORG':
                this.expOrgData = data;
                for (let i = 0; i < this.accDistData.length; i++) {
                  // 4 to this.accDistData.length
                  this.accDistData[i].expOrg = data;
                }
                // console.log('this.expOrgData')
                // console.log(this.expOrgData)
                break;
            }
            this.ref.markForCheck();
          }
        },
        error: (error: Error) => {
          // console.log(error);
          this.ams.showAlert(error.message, 'Error!');
          this.ref.markForCheck();
        },
      });
  }

  getProjectTaskData(projTaskPara) {
    this._dataService
      .ProjectTaskInfo_GetActiveByName([projTaskPara, 'CC'])
      .subscribe({
        next: (data) => {
          if (data) {
            this.projTaskData = data;
            this.projTaskData501c3 = this.projTaskData.filter(
              (projTask) => !projTask.task.includes('SPONSOR')
            );
            this.projTaskDataNon501c3 = this.projTaskData.filter(
              (projTask) => !projTask.task.includes('DONATION')
            );
            // console.log('this.projTaskData')
            // console.log(this.projTaskData)
            for (let i = 0; i < this.accDistData.length; i++) {
              // 4 to this.accDistData.length
              this.accDistData[i].project = _.uniqBy(
                this.projTaskData,
                'project'
              );
              this.accDistData[i].task = _.uniqBy(this.projTaskData, 'task');
            }
            this.filterExpTypeTask();
            this.ref.markForCheck();
          }
        },
        error: (error: Error) => {
          // console.log(error);
          this.ams.showAlert(error.message, 'Error!');
          this.ref.markForCheck();
          return of(error);
        },
      });
  }

  private populateCompany(value, index) {
    if (this.accDistData[0].company !== undefined) {
      this.ref.markForCheck();
      if (index === 0) {
        const selectedComp = this.accDistData[0].company.filter(
          (x) => x.code === value
        );
        let i = 1;
        for (i; i < this.accDistData.length; i++) {
          // 4 to this.accDistData.length
          this.accDistData[i].company = selectedComp;
          //  this.ccForm.controls['AccDistribution'].value[i].company = '';
          this.ccForm
            .get(['AccDistribution', i.toString(), 'company'])
            .setValue('');
        }
      } else {
        if (this.ccForm.controls['AccDistribution'].value[0].company === '') {
          this.ams.showAlert('Please select company for first row!', 'Error!');
          this.ccForm
            .get(['AccDistribution', index.toString(), 'company'])
            .setValue('');
          return;
        }
      }
    } else {
      this.populateCompany(value, index);
    }
  }

  onAccDistSelect(value, index: number, selectedData: string): void {
    if (value) {
      this.ValidatingRow = index;
      this.isValidatingRow = true;
      switch (selectedData) {
        case 'company':
          this.populateCompany(value, index);
          this.accDistData[index].project = [];
          this.accDistData[index].task = [];
          this.ccForm
            .get(['AccDistribution', index.toString(), 'project'])
            .setValue('');
          this.ccForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          this.accDistData[index].project = _.uniqBy(
            this.projTaskData.filter(
              (accDistData) => accDistData.company === value
            ),
            'project'
          );
          break;

        case 'project':
          this.accDistData[index].task = [];
          // this.ccForm.controls['AccDistribution'].value[index].task = '';
          this.ccForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');

          this.accDistData[index].task = _.uniqBy(
            this.projTaskData.filter(
              (accDistData) => accDistData.project === value
            ),
            'task'
          );
          break;
      }
    } else {
      if (selectedData === 'company') {
        this.accDistData[index].project = _.uniqBy(
          this.projTaskData,
          'project'
        );
      } else if (selectedData === 'project') {
        this.accDistData[index].task = _.uniqBy(this.projTaskData, 'task');
      }
    }
  }

  callValidateAPI() {
    for (let i = 0; i < this.accDistData.length; i++) {
      // 4 to this.accDistData.length
      const validateObj = this.ccForm.controls['AccDistribution'].value[i];
      if (
        validateObj.company !== '' &&
        validateObj.project !== '' &&
        validateObj.task !== '' &&
        validateObj.expType !== '' &&
        validateObj.expOrg !== ''
      ) {
        this.isFilled = true;
      } else if (
        validateObj.company === '' &&
        validateObj.project === '' &&
        validateObj.task === '' &&
        validateObj.expType === '' &&
        validateObj.expOrg === ''
      ) {
        this.isFilled = true;
      } else {
        this.isFilled = false;
        return;
      }
    }
  }

  Validate_Project_Task(data) {
    let validateObj: any = {
      project: data.project,
      task: data.task,
      expenditureType: data.expType,
      expenditureOrg: data.expOrg,
      company: data.company,
    };
    let jsonData = JSON.stringify(validateObj);
    this.ams.showLoader('Validating...');
    this._dataService.Validate_Project_Task(jsonData).subscribe({
      next: (data) => {
        this.ams.closeDialog();
        if (data) {
          this.validateResult = JSON.parse(data);
          this.isValid =
            this.validateResult.statusCode === 'VALID' ? true : false;
          if (!this.isValid) {
            // this.ams.showAlert(this.validateResult.statusCode, this.validateResult.statusMessage);
            const statusMessage = this.validateResult.statusMessage.replace(
              'ended <',
              'ended \n<'
            );
            this.ams.showAlert(this.validateResult.statusCode, statusMessage);
          }
          this.ref.markForCheck();
        } else {
          this.isValid = false;
        }
      },
      error: (error: Error) => {
        this.isValid = false;
        this.ams.closeDialog();
        this.ams.showAlert(error.message, 'Unable to validate!');
        this.ref.markForCheck();
      },
    });
  }

  // canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
  //   if (!this.isShowLeaveDialog) {
  //     this.ams.showConfirm('Alert!', ' Are you sure you want to navigate away from this page? If you proceed, ALL of your changes will be lost. Press Yes to continue, or Cancel to stay on the current page.');
  //     return this.ams.confirm.afterClosed().map(result => {
  //       return result === 'yes' ? true : false;
  //     }).first();
  //   } else {'
  //     return true;
  //   }
  // }

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.isShowLeaveDialog) {
      this.ams.showConfirm(
        'Alert!',
        ' Are you sure you want to navigate away from this page? If you proceed, ALL of your changes will be lost. Press Yes to continue, or Cancel to stay on the current page.'
      );
      return this.ams.confirm.afterClosed().pipe(
        map((result) => {
          if (result === 'yes') {
            return true;
          } else {
            return false;
          }
        }),
        first()
      );
    } else {
      return true;
    }
  }

  hasRole(role: string) {
    return this.permissionsService.hasRoles(role);
  }

  onAmountChange(value, index: number) {
    let tempAmount = ''; // =
    if (value !== '' && value.includes('.')) {
      const dec = value.split('.')[1];
      if (dec == '00' || dec == '' || dec == '0') {
        tempAmount = value.split('.')[0];
      } else {
        tempAmount = this.numPipe
          .transform(+parseFloat(value).toFixed(2), '1.2-2')
          .replace(/,/g, '');
      }
    } else {
      tempAmount = value;
    }
    this.ccForm
      .get(['AccDistribution', index.toString(), 'amount'])
      .setValue(tempAmount);
  }
  calculateTotalAmount() {
    const projectDetails = this.ccForm.controls['AccDistribution'].value;
    this.totalAmount = '0';
    let newTotalAmount = 0;
    projectDetails.forEach((project) => {
      let amount = project.amount;
      let newAmount;
      if (amount == undefined || amount == null || amount == '') {
        newAmount = 0;
      } else {
        newAmount = parseFloat(amount);
      }
      newTotalAmount += newAmount; //+(parseFloat(project.amount) || 0).toFixed(2);+
    });
    let temp = this.numPipe
      .transform(newTotalAmount.toFixed(2), '1.2-2')
      .replace(/,/g, '');
    temp = temp.split('.')[1] === '00' ? temp.split('.')[0] : temp;
    this.totalAmount = temp;
  }

  toHome() {
    // this.router.navigate(['']);
    const previousUrl = this.previousRouteService.getPreviousUrl();
    if (!previousUrl?.includes('admin')) {
      this.router.navigate(['']);
    } else {
      this.router.navigate([previousUrl]);
    }
  }

  onCancel() {
    this.toHome();
  }

  // var ext = myfile.split('.').pop();
  onW9FileChange(event) {
    this.w9FormName = [];
    this.w9Form = '';
    this.w9FileName = '';
    this.w9FileSize = '';
    this.ams.showLoader('Uploading file...');
    if (event.target.files.length > 0) {
      if (event.target.files[0].type !== 'application/pdf') {
        this.fileInput1.nativeElement.value = '';
        this.ams.closeDialog();
        // this.ams.showAlert('', 'Only PDF file is allowed, please choose another file');
        this.toastrService.warning(
          'Only PDF file is allowed, please choose another file'
        );
      } else {
        if (event.target.files[0].size > 10485760) {
          // max 10MB - 10485760
          this.fileInput1.nativeElement.value = '';
          this.ams.closeDialog();
          // this.ams.showAlert('', 'Attachment size exceeds the allowable limit, please choose another file');
          this.toastrService.warning(
            'Attachment size exceeds the allowable limit, please choose another file'
          );
        } else {
          this.w9FormName.push(event.target.files[0].name);

          const reader = new FileReader();
          reader.onload = this.handleReaderLoadedW9Form.bind(this);
          reader.readAsBinaryString(event.target.files[0]);
          reader.onloadend = () => {
            this.ams.closeDialog();
            this.ref.markForCheck();
          };

          this.w9FileName = event.target.files[0].name;
          this.ref.markForCheck();
          // this.w9FileSize = event.target.files[0].size;
        }
      }
    }
  }

  handleReaderLoadedW9Form(e) {
    let base64 = [];
    base64.push(btoa(e.target.result));
    this.w9Form = base64[0];

    this.w9FileSize = e.loaded;
  }

  resetFileInput1() {
    this.w9FormName = [];
    this.w9Form = '';
    this.w9FileName = '';
    this.w9FileSize = '';
    this.fileInput1.nativeElement.value = '';
  }

  onAddAttachFileChange(event) {
    // this.fileNames = [];
    // this.addAttachData = [];
    this.fileList = [];
    this.fileList = Array.from(event.target.files);
    if (this.fileList.length > 0) {
      if (this.fileList.length < 10) {
        let isPDFIndex = this.fileList.findIndex(
          (item) => item.type !== 'application/pdf'
        );
        // console.log('isPDFIndex ', isPDFIndex);
        if (isPDFIndex <= -1) {
          if (this.fileList.length + this.addAttachData.length <= 10) {
            let uploadFileSize: number = 0;
            let currentFileSize: number = 0;
            this.totalFileSize = 0;
            for (let i = 0; i < this.fileList.length; i++) {
              uploadFileSize += parseInt(this.fileList[i].size);
            }
            if (this.addAttachData.length > 0) {
              for (let i = 0; i < this.addAttachData.length; i++) {
                currentFileSize += parseInt(this.addAttachData[i].fileSize);
              }
            }
            this.totalFileSize = uploadFileSize + currentFileSize;
            // console.log('uploadFileSize', uploadFileSize)
            // console.log('current Size', currentFileSize)
            // console.log('totalFileSize', this.totalFileSize)
            if (this.totalFileSize < 10485760) {
              // let duplicateFile = this.addAttachData.forEach((addAttachData) => {
              //   this.fileList.forEach((fileList, index) => {
              //     return fileList.name === addAttachData.fileName
              //     // {  this.fileList.splice(index, 1);  }
              //   });
              // });

              let current = this.fileList.map(function (item) {
                return item.name;
              });
              let upload = this.addAttachData.map(function (item) {
                return item.fileName;
              });
              current = [...current, ...upload];
              // let final = current.concate(upload);
              let isDuplicate = current.some(function (item, idx) {
                return current.indexOf(item) != idx;
              });
              // console.log(isDuplicate)

              if (!isDuplicate) {
                for (let i = 0; i < this.fileList.length; i++) {
                  this.fileNames.push(this.fileList[i].name);

                  let fileName = this.fileList[i].name;
                  let fleSize = this.fileList[i].size;
                  let addAttachObj: any = {};
                  let reader: any = new FileReader();
                  reader.onload = function (e) {
                    let base64 = [];
                    base64.push(btoa(e.target.result));
                    addAttachObj.addAttachId = 0;
                    addAttachObj.fileName = fileName;
                    addAttachObj.fileSize = fleSize;
                    addAttachObj.fileBase64 = base64[0];
                    addAttachObj.deleteIt = false;
                  };
                  reader.readAsBinaryString(this.fileList[i]);
                  this.addAttachData.push(addAttachObj);
                  this.fileInput2.nativeElement.value = '';
                }
              } else {
                // this.ams.showAlert('', 'Some of the files are already attached');
                this.toastrService.warning(
                  'Some of the files are already attached'
                );
              }
            } else {
              this.fileInput2.nativeElement.value = '';
              this.toastrService.warning(
                'Attachment size exceeds the allowable limit, please remove some files'
              );
              // this.ams.showAlert('', 'Attachment size exceeds the allowable limit, please remove some files');
            }
          } else {
            this.fileInput2.nativeElement.value = '';
            // this.ams.showAlert('', 'Number of Attachments exceeds the allowable limit(10 files), please remove some files');
            this.toastrService.warning(
              'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
            );
          }
        } else {
          this.fileInput2.nativeElement.value = '';
          // this.ams.showAlert('', 'Only PDF files are allowed, please choose another file');
          this.toastrService.warning(
            'Only PDF files are allowed, please choose another file'
          );
        }
      } else {
        this.fileInput2.nativeElement.value = '';
        // this.ams.showAlert('', 'Number of Attachments exceeds the allowable limit(10 files), please remove some files');
        this.toastrService.warning(
          'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
        );
      }
    }
    // console.log(this.addAttachData);
  }

  removeFile(fileName) {
    this.fileNames.forEach((item, index) => {
      if (item === fileName) {
        this.fileNames.splice(index, 1);
      }
    });
    // // console.log(fileName)
    // this.fileArray.forEach((item, index) => {
    //   if (this.fileArray[index].fileName === fileName) {
    //     this.fileArray.splice(index, 1);
    //   }
    // });
    this.addAttachData.forEach((_item: any, index: string | number) => {
      if (this.addAttachData[index].fileName === fileName) {
        this.addAttachData.splice(index, 1);
        return false;
      }
      return true;
    });
    if (this.fileNames.length == 0) {
      this.resetFileInput2();
    }
    // // console.log(this.fileNames);
    // console.log(this.addAttachData);
  }

  resetFileInput2() {
    this.totalFileCount = 0;
    this.totalFileSize = 0;
    this.fileNames = [];
    // this.fileArray = [];
    this.fileList = [];
    this.addAttachData = [];
    this.fileInput2.nativeElement.value = '';
  }

  DownloadFormccW9File() {
    if (this.formId && this.w9FileSize !== '') {
      this.ams.showLoader('Downloading...');
      if (this.w9Form.length === 0) {
        this._dataService
          .DownloadAttachmentFileById(this.formId, 'CCW9')
          .subscribe((response) => {
            this.ams.closeDialog();
            if (response.size > 300) {
              saveAs(response, `${this.w9FileName}`);
            } else {
              this.ams.showAlert(
                'ERROR',
                `Unable to download ${this.w9FileName}`
              );
              this.ams.showAlert(
                `Unable to download ${this.w9FileName}`,
                'Error!'
              );
            }
          });
      } else {
        var elem = window.document.createElement('a');
        elem.href = 'data:application/pdf;base64,' + this.w9Form;
        elem.download = this.w9FileName;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
        this.ams.closeDialog();
      }

      // var elem = window.document.createElement('a');
      // elem.href = "data:application/pdf;base64," + this.w9Form;
      // elem.download = this.w9FileName;
      // document.body.appendChild(elem);
      // elem.click();
      // document.body.removeChild(elem);
      //   this.ams.closeDialog();
      // }, (error:Error) => {
      //   // console.log(error);
      //   this.ams.closeDialog();
      //   this.ams.showAlert('Error', 'Please try again later');
      // });
    }
  }

  // private DownloadAttachFile(fileName) {
  //   const arrayAddAttach = this.ciForm.get('AddAttach') as FormArray;
  //   const arrayW9Attach = this.ciForm.get('W9Attach') as FormArray;
  //   const attachments = [...arrayW9Attach.controls, ...arrayAddAttach.controls];
  //   const file = attachments.find((item) => {
  //     return item.value.attachName === fileName;
  //   });
  //   // console.log(file.value.attachName)
  //   if (file.value.attachId !== -1) {
  //     // this.ams.showLoader('Downloading...');
  //     const mvcUrl = environment.MVC_URL;
  //     const corpSession = this.permissionsService.getCorpCommonSessionInfo();
  //     const corpDataDef = encodeURIComponent('{"ProcessDataAction":"DOWNLOAD_FORMCI_ATTACHMENT","AppDataDefinition":[' + file.value.attachId.toString() + ']}');
  //     let url = `${mvcUrl}/AppData/GetFileData?sid=${corpSession.corpAuthToken}&userID=${corpSession.corpUn}&applicationID=${corpSession.appId}&corpProcessDataDefinition=${corpDataDef}`;

  //     window.open(url, '_blank');
  //     this.ams.closeDialog();
  //   }

  // }

  DownloadFormccAddAttachFile(fileName) {
    let file = this.addAttachData.filter((item) => {
      return item.fileName === fileName;
    });
    // console.log(file[0])
    if (file[0].addAttachId) {
      this.ams.showLoader('Downloading...');
      this._dataService
        .DownloadAttachmentFileById(file[0].addAttachId, 'CCAdd')
        .subscribe({
          next: (response) => {
            this.ams.closeDialog();
            if (response.size > 300) {
              saveAs(response, `${file[0].fileName}`);
            } else {
              this.ams.showAlert(
                'ERROR',
                `Unable to download ${file[0].fileName}`
              );
            }
          },
          error: (error) => {
            this.ams.showAlert('ERROR', error);
          },
        });
    } else {
      var elem = window.document.createElement('a');
      elem.href = 'data:application/pdf;base64,' + file[0].fileBase64;
      elem.download = file[0].fileName;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }

  DownloadFormccAllAddAttachFile() {
    if (this.formId) {
      this.addAttachData.forEach((item) => {
        this.DownloadFormccAddAttachFile(item.addAttachId);
      });
      //   this.ams.showLoader('Downloading...');
      //   this._dataService.DownloadFormccAllAddAttachFile(this.formId)
      //     .then(data => {
      //       // console.log(data);
      //       for (let i = 0; i < data.length; i++) {
      //         // console.log(data[i])
      //         var elem = window.document.createElement('a');
      //         elem.href = "data:application/pdf;base64," + data[i].fileBase64;
      //         elem.download = data[i].fileName;
      //         document.body.appendChild(elem);
      //         elem.click();
      //         document.body.removeChild(elem);
      //       }
      //       this.ams.closeDialog();
      //     }, (error:Error) => {
      //       // console.log(error);
      //       this.ams.closeDialog();
      //       this.ams.showAlert('Error', 'Please try again later');
      //     });
    }
  }

  onSaveAsDraft() {
    // this._dataService.setFormCCName(this.ccForm.get('formCCName').value);

    this.ams.showConfirmation(
      'Are you sure you want to save as draft?',
      'CC',
      this.ccForm.get('formCCName').value,
      30
    );
    this.ams.confirmation.afterClosed().subscribe((result) => {
      if (result && result.formName) {
        this.formCCName = result.formName;

        const updatedDueDate = this.ccForm.get('dueDate').value;
        this.ccForm.get('dueDate').setValue(new Date(updatedDueDate));

        const updatedEffdt = this.ccForm.get('effdt').value;
        this.ccForm.get('effdt').setValue(new Date(updatedEffdt));

        this.ccForm.value.totalAmount = this.totalAmount.toString();
        this.ccForm.value.formCCName = this.formCCName;
        this.ccForm.value.statusId = 2;
        this.ccForm.value.formFlag = 'CC';
        this.ccForm.value.deleteIt = 'false';
        if (this.ccForm.value.userId === '') {
          this.ccForm.value.userId = this.userDetails.userId;
        }

        this.ccForm.value.w9Form = this.w9Form;
        this.ccForm.value.w9FileName = this.w9FileName;
        this.ccForm.value.w9FileSize = this.w9FileSize;

        this.ccForm.value.addAttachData = this.addAttachData;

        // console.log('this.ccForm.value in Draft');
        // console.log(this.ccForm.value);

        this.ams.showLoader('Drafting...');
        this._dataService.ccFormIUD(this.ccForm.value).subscribe({
          next: (response) => {
            this.ams.closeDialog();
            // console.log(response);
            if (response === 'error') {
              this.ams.showAlert(
                'Error!',
                'Please try again later or contact support!'
              );
            } else {
              this.ams.showAlert('Success!', 'Successfully Drafted!');
              this.isShowLeaveDialog = true;
              let leaving = setTimeout(() => {
                this.ams.closeDialog();
                this.toHome();
              }, 5000);
              this.ams.alert.afterClosed().subscribe(() => {
                this.toHome();
                clearTimeout(leaving);
              });
              // this.router.navigate(['']);
            }
          },
          error: (error: Error) => {
            this.ams.closeDialog();
            this.ams.showAlert('Error!', error.message);
            // console.log(error);
            // console.log(this.ccForm.get('dueDate'));
            return of(Error);
          },
        });
        this._dataService.setFormCCName('');
      }
    });
  }

  onSubmit() {
    if (this.w9FileSize === '') {
      // console.log(this.w9Form.length)
      // this.ams.showAlert('', 'Please attach W9 form');
      this.toastrService.warning('Please attach W9 form');
    } else if (this.ccForm.invalid) {
      // this.ams.showAlert('Alert', 'Please complete all required field(s) marked with an *');
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
      this.ccForm.markAllAsTouched();
    } else if (!this.isFilled) {
      this.ams.showAlert(
        'Alert',
        'Please fill missing field(s) on Accounting Distribution!'
      );
    } else if (!this.isValid) {
      this.ams.showAlert(
        'Alert',
        'Your Accounting Distribution combination is invalid!'
      );
    } else {
      // this._dataService.setFormCCName(this.ccForm.get('formCCName').value);

      this.ams.showConfirmation(
        'Are you sure you want to submit?',
        'CC',
        this.ccForm.get('formCCName').value,
        30
      );
      this.ams.confirmation.afterClosed().subscribe((result) => {
        if (result && result.formName) {
          this.formCCName = result.formName;

          const updatedDueDate = this.ccForm.get('dueDate').value;
          this.ccForm.get('dueDate').setValue(new Date(updatedDueDate));
          // const updatedDueDate = this.ccForm.get('dueDate').value;
          // if (updatedDueDate !== "") {
          //   this.ccForm.get('dueDate').setValue(new Date(updatedDueDate));
          // }

          const updatedEffdt = this.ccForm.get('effdt').value;
          this.ccForm.get('effdt').setValue(new Date(updatedEffdt));

          this.ccForm.value.totalAmount = this.totalAmount.toString();
          this.ccForm.value.formCCName = this.formCCName;

          // if (
          //   this.ccForm.value.statusId === 2 ||
          //   this.ccForm.value.statusId === 7 ||
          //   this.ccForm.value.statusId === 23 ||
          //   this.ccForm.value.statusId === null
          // ) {
          //   this.ccForm.value.statusId = 1;
          // }
          let statusId = this.ccForm.value.statusId;
          this.ccForm.value.statusId = [2,7,23].includes(this.ccForm.value.statusId) || !this.ccForm.value.statusId ? 1 : (statusId && statusId === 1 ? 23 : statusId);
          
          this.ccForm.value.formFlag = 'CC';
          this.ccForm.value.deleteIt = 'false';
          if (this.ccForm.value.userId === '') {
            this.ccForm.value.userId = this.userDetails.userId;
          }

          this.ccForm.value.w9Form = this.w9Form;
          this.ccForm.value.w9FileName = this.w9FileName;
          this.ccForm.value.w9FileSize = this.w9FileSize;

          this.ccForm.value.addAttachData = this.addAttachData;

          // console.log('this.ccForm.value');
          // console.log(this.ccForm.value);

          this.ams.showLoader(
            this.isShowSaveAsDraft ? 'Submitting...' : 'Saving...'
          );
          this._dataService.ccFormIUD(this.ccForm.value).subscribe({
            next: (response) => {
              // console.log(response);
              this.ams.closeDialog();
              this.isShowLeaveDialog = true;
              // console.log(response);
              if (response === 'error') {
                // this.ams.showAlert('Error!', response.message);
                this.ams.showAlert('Error', response.message);
              } else {
                this.ams.showAlert(
                  'Success!',
                  this.isShowSaveAsDraft
                    ? 'Successfully submitted!'
                    : 'Successfully saved!'
                );
                let leaving = setTimeout(() => {
                  this.ams.closeDialog();
                  this.toHome();
                }, 5000);
                this.ams.alert.afterClosed().subscribe(() => {
                  this.toHome();
                  clearTimeout(leaving);
                });
                // this.ccForm.get('dueDate').setValue(null);  // added newly
              }
            },
            error: (error: Error) => {
              this.ams.closeDialog();
              // this.ams.showAlert('Error!', JSON.stringify(error));
              this.ams.showAlert('Error', JSON.stringify(error));
              this.ccForm.get('effdt').setValue(new Date(updatedEffdt));
            },
          });

          this._dataService.setFormCCName('');
        }
      });
    }
  }

  onApprove() {
    // console.log(this.pendingApprovalFormCCData)

    let data: any = {};
    data.formCCId = this.pendingApprovalFormCCData.FormCCLogInfo.formCCId;
    data.formCCLogId = this.pendingApprovalFormCCData.FormCCLogInfo.formCCLogId;
    data.empId = this.pendingApprovalFormCCData.FormCCLogInfo.empId;
    data.empName = this.pendingApprovalFormCCData.FormCCLogInfo.empName;
    data.action = 'Approved';
    data.orgName = this.pendingApprovalFormCCData.OrgInfo.name;
    data.totalAmount = this.pendingApprovalFormCCData.totalAmount;
    data.status = this.pendingApprovalFormCCData.FormCCLogInfo.status;
    data.email = '';
    data.userId = this.pendingApprovalFormCCData.userId;
    data.empTypeForLog =
      this.pendingApprovalFormCCData.FormCCLogInfo.empTypeForLog;
    data.empTitle = this.pendingApprovalFormCCData.FormCCLogInfo.title;

    this.ams.showApproveReject('Are you sure you want to Approve?', '');
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        // // console.log(result);
        // // console.log(result.comment);
        data.comment = result.comment;
        // console.log(data);
        this.ams.showLoader('Approving...');
        this._dataService.AprrovedOrRejectFormCC(data).subscribe({
          next: (data) => {
            if (data === 'DAONOTFOUND') {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has alredy been approved!'
              );
              // this.router.navigate(['']);
              this.ref.markForCheck();
            } else if (data === 'AANOTFOUND') {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has alredy been approved!'
              );
              // this.router.navigate(['']);
              this.ref.markForCheck();
            } else if (data === 'ALREADYDONE') {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has alredy been approved!'
              );
              // this.router.navigate(['']);
              this.ref.markForCheck();
            } else {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert('Success!', 'Successfully approved!');
              // this.router.navigate(['']);
              this.ref.markForCheck();
            }
            this.isShowLeaveDialog = true;
            let leaving = setTimeout(() => {
              this.ams.closeDialog();
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error: Error) => {
            // console.log(error);
            this.ams.closeDialog();
            // this.ams.showAlert('Error!', JSON.stringify(error));
            this.ams.showAlert('ERROR', JSON.stringify(error));
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onReject() {
    // console.log(this.pendingApprovalFormCCData)
    let data: any = {};
    data.formCCId = this.pendingApprovalFormCCData.FormCCLogInfo.formCCId;
    data.formCCLogId = this.pendingApprovalFormCCData.FormCCLogInfo.formCCLogId;
    data.action = 'Rejected';
    data.orgName = this.pendingApprovalFormCCData.OrgInfo.name;
    data.totalAmount = this.pendingApprovalFormCCData.totalAmount;
    data.status = this.pendingApprovalFormCCData.FormCCLogInfo.status;
    data.email = '';
    data.userId = this.pendingApprovalFormCCData.userId;
    data.empTypeForLog =
      this.pendingApprovalFormCCData.FormCCLogInfo.empTypeForLog;
    data.empId = this.pendingApprovalFormCCData.FormCCLogInfo.empId;
    data.empName = this.pendingApprovalFormCCData.FormCCLogInfo.empName;
    data.empTitle = this.pendingApprovalFormCCData.FormCCLogInfo.title;

    this.ams.showApproveReject('Are you sure you want to Reject?', '');
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        data.comment = result.comment;
        // console.log(data);
        this.ams.showLoader('Rejecting...');
        this._dataService.AprrovedOrRejectFormCC(data).subscribe({
          next: (data) => {
            // console.log(data);
            this.ams.closeDialog();
            if (data === 'DAONOTFOUND') {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has alredy been rejected!'
              );
              // this.router.navigate(['']);
              this.ref.markForCheck();
            } else if (data === 'AANOTFOUND') {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has alredy been rejected!'
              );
              // this.router.navigate(['']);
              this.ref.markForCheck();
            } else if (data === 'ALREADYDONE') {
              // console.log(data);
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has alredy been rejected!'
              );
              // this.router.navigate(['']);
              this.ref.markForCheck();
            } else {
              this.ams.showAlert('Success!', 'Successfully Rejected!');
              // this.router.navigate(['']);
              this.ref.markForCheck();
            }
            this.isShowLeaveDialog = true;
            let leaving = setTimeout(() => {
              this.ams.closeDialog();
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error: Error) => {
            // console.log(error);
            this.ams.closeDialog();
            // this.ams.showAlert('Error!', JSON.stringify(error));
            this.ams.showAlert('Error', JSON.stringify(error));
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onWithdrawn() {
    // console.log(this.pendingApprovalFormCCData)
    let data: any = {};
    if (this.userDetails !== null) {
      data.empId = this.userDetails.userId;
      data.empName = this.userDetails.userName.toUpperCase();
      data.empTitle = '';
      data.action = 'Withdrawn';

      data.formCCId = this.pendingApprovalFormCCData.FormCCLogInfo.formCCId;
      data.formCCLogId =
        this.pendingApprovalFormCCData.FormCCLogInfo.formCCLogId;
      data.orgName = this.pendingApprovalFormCCData.OrgInfo.name;
      data.totalAmount = this.pendingApprovalFormCCData.totalAmount;
      data.status = this.pendingApprovalFormCCData.FormCCLogInfo.status;
      data.email = '';
      data.userId = this.pendingApprovalFormCCData.userId;
      data.empTypeForLog =
        this.pendingApprovalFormCCData.FormCCLogInfo.empTypeForLog;

      this.ams.showApproveReject('Are you sure you want to Withdraw?', '');
      this.ams.approveReject.afterClosed().subscribe((result) => {
        if (result) {
          data.comment = result.comment;
          // console.log(data);
          this.ams.showLoader('Withdrawing...');
          this._dataService.AprrovedOrRejectFormCC(data).subscribe({
            next: (data) => {
              if (data) {
                // console.log(data);
                this.ams.closeDialog();
                this.toastrService.success(
                  'Success!',
                  'Successfully Withdrawn!'
                );
                this.isShowLeaveDialog = true;
                let leaving = setTimeout(() => {
                  this.ams.closeDialog();
                  this.toHome();
                }, 5000);
                this.ams.alert.afterClosed().subscribe(() => {
                  this.toHome();
                  clearTimeout(leaving);
                });
                this.ref.markForCheck();
              } else {
                this.ref.markForCheck();
              }
            },
            error: (error: Error) => {
              // console.log(error);
              this.ams.closeDialog();
              // this.ams.showAlert('Error!', JSON.stringify(error));
              this.ams.showAlert('Error', JSON.stringify(error));
              this.ref.markForCheck();
            },
          });
        }
      });
    } else {
      console.error('user Detaiis is null!');
      // this.ams.showAlert('Error!', 'user Details is null!');
      this.ams.showAlert('Error', 'User Details is null!');
    }
  }

  // Create reactive forms
  private createForms(): void {
    this.ccForm = this.fb.group({
      AccDistribution: this.fb.array([
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: ['', Validators.required],
          project: ['', Validators.required],
          task: ['', Validators.required],
          expType: ['', Validators.required],
          expOrg: ['', Validators.required],
          amount: ['', [Validators.required]],
          formFlag: [''],
        }),
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
          formFlag: [''],
        }),
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
          formFlag: [''],
        }),
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
          formFlag: [''],
        }),
      ]),
      OrgContactInfo: this.fb.group({
        orgContactInfoId: [null],
        title: ['', Validators.required],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{3}-\d{3}-\d{4}/)),
          ],
        ],
        email: [
          '',
          [
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(
              new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
            ),
          ],
        ],
      }),
      OrgInfo: this.fb.group({
        orgInfoId: [null],
        isInternal: [false],
        name: ['', [Validators.required, Validators.maxLength(80)]],
        payToOption: ['no'],
        payTo: ['', Validators.maxLength(80)],
        EIN: [
          '',
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern(new RegExp(/^\d{2}-\d{7}/)),
          ],
        ],
        // EIN: ['', [Validators.required, Validators.maxLength(10)]],
        address1: ['', [Validators.required, Validators.maxLength(35)]],
        address2: ['', [Validators.maxLength(35)]],
        city: ['', [Validators.required, Validators.maxLength(25)]],
        state: ['', Validators.required],
        zipCode: [
          '',
          [
            Validators.required,
            Validators.maxLength(9),
            Validators.pattern(new RegExp(/^\d{5}$|^\d{9}$/)),
          ],
        ],
        webAddress: [''],
        subsection_501: [''],
      }),
      FormCCLogInfo: this.fb.group({
        action: [''],
        comment: [''],
        effdt: [''],
        empId: [''],
        empName: [''],
        empTypeForLog: [''],
        formCCId: [null],
        formCCLogId: [null],
        title: [''],
        status: [''],
        isDOA: [''],
        isAA: [''],
      }),
      FormCCOeBS: this.fb.group({
        DeleteIt: [false],
        formccId: [null],
        oebsId: [null],
        invoiceNo: [''],
        company: [''],
        uploadInvoiceDate: [''],
        uploadStatusCode: [''],
        uploadStatusMessage: [''],
        validateInvoiceDate: [''],
        validateStatusCode: [''],
        validateStatusMessage: [''],
      }),

      addAttach: [''],
      confirmationNoCC: [''],
      checkMemo: ['', [Validators.maxLength(45)]],
      // company: [''],
      contribTable: ['no'],
      contribTableDescr: ['', [Validators.maxLength(50)]],
      deleteIt: [''],
      dueDate: [''],
      effdt: [new Date(), Validators.required],
      eventOrProgram: ['program', Validators.required],
      eventOrProgramName: ['', [Validators.required, Validators.maxLength(50)]],
      formCCName: ['', [Validators.required, Validators.maxLength(30)]],
      formccId: [null],
      goodsAndServices: ['no', Validators.required],
      grantPurpose: ['', Validators.required],
      orgContactInfoId: [null],
      orgInfoId: [null],
      payment: ['CHECK', Validators.required],
      publicAck: ['', [Validators.required, Validators.maxLength(254)]],
      requestNo: [''],
      serviceArea: [[], Validators.required],
      serviceAreaArray: [[]],
      statusDescr: [''],
      statusEffdt: [''],
      statusId: [null],
      supportedPast: ['no', Validators.required],
      totalAccDist: [null],
      totalAmount: [''],
      userId: [''],

      w9Form: [''],
      w9FileName: [''],
      w9FileSize: [''],

      FormCCAddAttach: [],
    });

    // this.ccForm.get('w9Form').valueChanges.subscribe((value) => {
    //   // console.log(value);
    // })

    this.getAccountingDistributionData('COMPANY');
    this.getAccountingDistributionData('EXP_TYPE');
    this.getAccountingDistributionData('EXP_ORG');
    this.getProjectTaskData('PROJ_TASK_PLUS');

    this.ccForm.controls['AccDistribution'].valueChanges.subscribe((value) => {
      let validateObj = value[this.ValidatingRow];
      if (validateObj !== undefined) {
        if (
          validateObj.company !== '' &&
          validateObj.project !== '' &&
          validateObj.task !== '' &&
          validateObj.expType !== '' &&
          validateObj.expOrg !== '' &&
          this.isValidatingRow
        ) {
          this.Validate_Project_Task(validateObj);
          this.isValidatingRow = false;
        }
        this.callValidateAPI();
      }
      // else {
      //   for (let i = 0; i< value.length; i++) {
      //     const accDist = value[i];
      //     const tempAmount = accDist.amount !== '' && accDist.amount.includes('.')?this.numPipe.transform(+parseFloat(accDist.amount).toFixed(2),'1.2-2').replace(',',''):'';
      //     this.ccForm.get(['AccDistribution',i.toString(),'amount']).setValue(tempAmount);
      //   };
      // }
    });

    // this.ccForm.get('amount').valueChanges.subscribe(value => {
    //   this.isValidatingRow = false;
    // });
    // old logic by Mayur which required seperate table module, now checking for approver on loadStateData subscription
    // this.asAnApprovar = this.formCCService.getpendingApprovalFormCCData() === null ? false : true;

    // console.log('this.asAnApprovar: ', this.asAnApprovar);
    this.isApproved =
      this.formCCService.getApprovedFormCCData() === null ? false : true;
    // console.log('this.isApproved: ', this.isApproved);
    this.asAnAdmin =
      this.formCCService.getIsAdminReject() === null ? false : true;
    // console.log('this.asAnAdmin: ', this.asAnAdmin);
    // console.log(this.orgInfoData);

    this.orgInfoData = this.formCCService.getOrgInfoDetails();
    if (this.orgInfoData !== null) {
      (<FormControl>this.ccForm.controls['OrgInfo']).setValue(this.orgInfoData);
    }

    this.ccForm.get('effdt').valueChanges.subscribe((value) => {
      this.minDuedt = value;
    });

    if (!this.formId) {
      this.minEffdt = new Date();
      this.minDuedt = new Date();
    }

    this.calculateTotalAmount();

    (<FormGroup>this.ccForm.controls['OrgInfo']).controls[
      'payToOption'
    ].valueChanges.subscribe((value: string) => {
      this.payToOption = value === 'yes';
      if (!this.payToOption) {
        (<FormGroup>this.ccForm.controls['OrgInfo']).controls['payTo'].setValue(
          ''
        );
        (<FormGroup>this.ccForm.controls['OrgInfo']).controls[
          'payTo'
        ].setValidators([]);
        this.ccForm
          .get(['OrgInfo', 'name'])
          .setValidators([Validators.required, Validators.maxLength(80)]);
      } else {
        (<FormGroup>this.ccForm.controls['OrgInfo']).controls[
          'payTo'
        ].setValidators([Validators.required]);
        this.ccForm
          .get(['OrgInfo', 'name'])
          .setValidators([Validators.required]);
      }
      this.ccForm.get('OrgInfo').updateValueAndValidity();
    });

    this.ccForm
      .get(['OrgInfo', 'subsection_501'])
      .valueChanges.subscribe((value) => {
        this.filterExpTypeTask();
      });

    this.ccForm
      .get('eventOrProgram')
      .valueChanges.subscribe((value: string) => {
        this.eventOrProgram = value === 'event';
        this.ccForm
          .get('contribTable')
          .setValidators(this.eventOrProgram ? [Validators.required] : []);
        this.ccForm.get('contribTable').updateValueAndValidity();
        this.ccForm.get('contribTableDescr').setValidators([]);
        this.ccForm.get('contribTableDescr').updateValueAndValidity();
        if (!this.eventOrProgram) {
          this.ccForm.get('contribTable').setValue('');
          this.ccForm.get('contribTableDescr').setValue('');
        }
      });

    this.ccForm.get('contribTable').valueChanges.subscribe((value: string) => {
      this.contribTable = value === 'yes';
      this.ccForm
        .get('contribTableDescr')
        .setValidators(this.contribTable ? [Validators.required] : []);
      this.ccForm.get('contribTableDescr').updateValueAndValidity();
      if (!this.contribTable) {
        this.ccForm.get('contribTableDescr').setValue('');
      }
    });
  }
  // End reactive forms

  // Select state
  private selectState(): void {
    // this.userDetails$ = this.store.select(fromAuth.getUser);

    this.pending$ = this.store.select(
      fromCharitableContribution.getCharitableContributionScreenPending
    );
    this.error$ = this.store
      .select(fromCharitableContribution.getCharitableContributionScreenError)
      .pipe(
        skipWhile(
          (error) => error === undefined || error === null || error === ''
        )
      );
    this.stateData$ = this.store.select(
      fromCharitableContribution.getCharitableContributionState
    );
  }

  private displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading...');
        this.ref.markForCheck();
      });
    } else {
      this.ams.closeDialog().then(() => {
        if (
          this.error !== null &&
          this.error !== undefined &&
          this.error !== ''
        ) {
          this.displayError(this.error);
        }
      });
    }
  }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    // this.ams.showAlert('Loading Error', errorMessage);
    this.ams.showAlert(errorMessage, 'Loading Error');
    this.ams.alert.afterClosed().subscribe((result) => {
      this.store.dispatch(
        new CharitableContributionAction.CharitableContributionScreenErrorReset()
      );
    });
  }

  // Opens sidenav if on mobile
  openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }

  // Subscribe to state data and mark it for changes
  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      this.pending = data;
      this.displayLoader(this.pending);
      this.ref.markForCheck();
    });

    this.stateDataSubscription = this.stateData$.subscribe((data) => {
      // console.log(this.formId);
      if (data !== null && data[0].formccId === this.formId) {
        this.pendingApprovalFormCCData = data[0];
        this.formData = JSON.parse(JSON.stringify(data[0]));
        this.formData.serviceArea = this.formData.serviceAreaArray;

        this.w9FormName[0] = this.formData.w9FileName;
        // this.w9Form = this.formData.w9Form;
        this.w9FileName = this.formData.w9FileName;
        this.w9FileSize = this.formData.w9FileSize;
        // this.fileArray = this.formData.FormCCAddAttach;
        this.addAttachData = this.formData.FormCCAddAttach;
        if (this.addAttachData.length > 0) {
          this.fileNames = [];
          for (let i = 0; i < this.addAttachData.length; i++)
            this.fileNames.push(this.addAttachData[i].fileName);
        }

        this.minEffdt = new Date(this.formData.effdt);

        this.ccForm.setValue(this.formData);

        this.ccForm.get('effdt').setValue(new Date(this.formData.effdt));

        if (this.ccForm.get('dueDate').value) {
          this.ccForm.get('dueDate').setValue(new Date(this.formData.dueDate));
        }
        this.checkOrgName();
        this.calculateTotalAmount();
        let isAdminEditable = true;
        // Only Editable if open from payment process (CHECK/CREDIT/FOUNDATION TRUSTEE) by ADMIN.
        // Check with Mayur for reason.
        switch (this.previousRouteService.getPreviousUrl()) {
          case 'payment-foundation-trustee':
          case 'payment-check':
          case 'payment-credit':
            isAdminEditable = !this.hasRole('ADMIN'); // should have role ADMIN if can access these pages
            this.isShowSaveAsDraft = false;
            break;
        }

        switch (this.formData.statusDescr) {
          case 'Submitted':
            this.atOeBs = false;
            this.isReadOnly = this.hasRole('DEV');; // this.formData.statusDescr === 'Submitted' ? false : true;
            this.isShowLeaveDialog = true; // this.formData.statusDescr === 'Submitted' ? true : false;
            this.isShowSaveAsDraft = this.hasRole('DEV');
            break;
          case 'Approved':
            this.atOeBs = false;
            this.isReadOnly = isAdminEditable; // this.formData.statusDescr === 'Approved' ? false : true;
            this.isShowLeaveDialog = true; // this.formData.statusDescr === 'Approved' ? true : false;
            this.isShowSaveAsDraft = false;
            // this.asAnApprovar = false;
            // console.log(this.asAnApprovar, this.asAnAdmin, this.atOeBs);
            break;
          case 'PendingApproval':
            this.atOeBs = false;
            this.isReadOnly = this.hasRole('ADMIN') || this.hasRole('APPROVER'); // this.formData.statusDescr === 'PendingApproval' ? false : true;
            this.isShowLeaveDialog = true; //this.formData.statusDescr === 'PendingApproval' ? true : false;
            this.isShowSaveAsDraft = false;
            break;
          case 'Rejected':
            this.atOeBs = true;
            this.isWithdrawn = false;
            // this.isReadOnly = this.formData.statusDescr === 'Rejected' ? false : true;
            this.isShowLeaveDialog = true; // this.formData.statusDescr === 'Rejected' ? true : false;
            this.isShowSaveAsDraft = false;
            break;
          case 'Withdrawn':
          case 'Waiting For Oracle':
          case 'Sent To Oracle':
          case 'Sent To Foundation Trustee':
          case 'Negotiable':
          case 'Reconciled':
          case 'Voided':
          case 'Denied':
          case 'Cleared':
          case 'Cancelled':
          case 'Paid Credit':
            this.atOeBs = true;
            this.isReadOnly = this.hasRole('DEV'); //this.formData.statusDescr === 'Paid Credit' ? false : true;
            this.isShowLeaveDialog = true; //this.formData.statusDescr === 'Paid Credit' ? true : false;
            break;
        }
        if (this.formData.statusDescr === 'PendingApproval') {
          this.asAnApprovar =
            this.hasRole('APPROVER') &&
            this.permissionsService.getUserId() ===
              this.formData.FormCCLogInfo.empId;
        }
      }
      this.ref.markForCheck();
    });

    // if (this.formId) {
    // } else {
    // }
    this.errorSubscription = this.error$.subscribe((data) => {
      this.error = data;
      this.ref.markForCheck();
    });

    // this.userDetailsSubscription = this.userDetails$
    //   .subscribe(data => {
    //     this.userDetails = data;
    //     // this.ref.markForCheck();
    //   });
    // this.stateDataSubscription = this.stateData$
    // .subscribe(data => {
    //     this.stateData = data;
    //     this.ref.markForCheck();
    // });
  }
  private checkOrgName() {
    const name = this.ccForm.get(['OrgInfo', 'name']).value;
    if (name.length > 80) {
      this.ccForm.get(['OrgInfo', 'payToOption']).setValue('yes');
      if (this.ccForm.get(['OrgInfo', 'payTo']).value.length === 0) {
        this.ccForm.get(['OrgInfo', 'payTo']).setValue(name.substring(0, 80));
      }
      this.ccForm.get(['OrgInfo', 'name']).setValue(name);
      this.isMaxLength = true;
    }
  }

  private filterExpTypeTask() {
    if (!this.hasRole('ADMIN')) {
      if (this.ccForm.get(['OrgInfo', 'subsection_501']).value === '03') {
        this.projTaskData = this.projTaskData501c3;
        this.expTypeData = this.expTypeData501c3;
        // console.log('this.projTaskData')
        // console.log(this.projTaskData)
      } else {
        this.projTaskData = this.projTaskDataNon501c3;
        this.expTypeData = this.expTypeDataNon501c3;
        // console.log('this.projTaskData')
        // console.log(this.projTaskData)
      }
    }
    for (let i = 0; i < this.accDistData.length; i++) {
      // 4 to this.accDistData.length
      let project = this.ccForm.get([
        'AccDistribution',
        i.toString(),
        'project',
      ]).value;
      this.accDistData[i].expType = this.expTypeData;
      if (project !== '')
        this.accDistData[i].task = _.uniqBy(
          this.projTaskData.filter(
            (accDistData) => accDistData.project === project
          ),
          'task'
        );
      else this.accDistData[i].task = _.uniqBy(this.projTaskData, 'task');
    }
  }
  // Unsubscribe from state data changes
  private endSubscriptions(): void {
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    // this.stateDataSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.endSubscriptions();
    this.formCCService.setpendingApprovalFormCCData(null);
    this.formCCService.setApprovedFormCCData(null);
    this.formCCService.setIsAdminReadOnly(null);
    this.formCCService.setOrgInfoDetails(null);
    this.formCCService.setIsAdminReject(null);
  }

  getTaxExemptStatus(value) {
    if (value === '') return 'Other';
    else if (isNaN(value) || +value === 0) {
      return value;
    } else {
      return `501(c)(${+value})`;
    }
  }
}
